import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let Empty = class Empty extends Vue {
    emptyIcon = require('@blade-sxp/tools/assets/images/emptyImgGray.svg');
};
Empty = __decorate([
    Component({
        name: 'empty',
        i18n: {
            messages: {
                en: {
                    remark: 'Please select portrait, portrait library and enter similarity threshold to start searching',
                },
                zh: {
                    remark: '请选择人像、人像库和相似度阈值进行检索',
                }
            }
        }
    })
], Empty);
export default Empty;
